import { render } from "./AttendWeekly.vue?vue&type=template&id=71fe68e0&scoped=true"
import script from "./AttendWeekly.vue?vue&type=script&lang=js"
export * from "./AttendWeekly.vue?vue&type=script&lang=js"

import "./AttendWeekly.vue?vue&type=style&index=0&id=71fe68e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fe68e0"]])

export default __exports__